<template>
  <section class="home-programs__container">
    <BackgroundBlade
      class="home-programs__background"
    />
    <div class="home-programs">
      <router-link
        v-for="({ slug, image, heading }) in categories"
        :key="slug"
        :to="{ name: 'category', params: { category: slug } }"
        class="home-program"
      >
        <div class="home-program__image-container">
          <BaseImage
            :id="image"
            class="home-program__image"
          />
        </div>
        <div class="home-program__heading-container">
          <div
            class="home-program__heading"
            v-text="heading"
          />
        </div>
      </router-link>
    </div>
    <div class="home-programs__about">
      <h3 class="home-programs__about-heading">Programs</h3>
      <div class="home-programs__about-body">
        <p class="home-programs__about-copy">
          <!-- eslint-disable-next-line max-len -->
          Our instruction is built to challenge you, make you better, in a constructive and encouraging environment. We offer programs for all ages.
        </p>
        <div class="home-programs__about-link--wrapper">
          <LinkButton
            :to="{ name: 'programs'}"
            class="home-programs__about-link"
          >
            Discover our Programs
          </LinkButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Category from '@/api/categories';

  import LinkButton from './LinkButton';
  import BackgroundBlade from './BackgroundBlade';

  export default {
    components: {
      LinkButton,
      BackgroundBlade,
    },
    data() {
      return {
        categories: undefined,
      };
    },
    async created() {
      this.categories = (await Category.all()).map(this.cleanCategory);
    },
    methods: {
      cleanCategory({
        name,
        slug,
        acf: {
          home_tile: {
            image,
            heading,
          },
        },
      }) {
        return {
          slug,
          image,
          heading: heading || name,
        };
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>

  .home-programs__container {
    @include container;
    position: relative;
    overflow: hidden;
    padding-top: spacing(base-epsilon);
    padding-bottom: spacing(base-epsilon);

    @include breakpoint(phablet) {
      padding-top: spacing(base-zeta);
      padding-bottom: spacing(base-eta);
    }
  }

  .home-programs {
    @include column;
    display: flex;
    flex-direction: column;
    width: 100%;

    @include breakpoint(phablet) {
      flex-direction: row;
    }
  }

  .home-program {
    position: relative;
    width: 100%;
    margin-top: spacing(delta);
    background-color: color(bronze);

    &:first-child {
      margin-top: 0;
    }

    @include breakpoint(phablet) {
      // width: 33.333%;
      margin-top: 0;
      border-right: 1px solid color(white);

      &:last-child {
        border: 0;
      }
    }
  }

  .home-program__image-container {
    position: relative;
    padding-top: percentage(9 / 16);

    @include breakpoint(phablet) {
      padding-top: percentage(4 / 3);
    }
  }

  .home-program__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .home-program__heading {
    font-family: font-family(serif);
    font-size: 2.6rem;
    color: color(white);
    transition-duration: duration(fast);
    transition-property: color;
    transition-timing-function: timing-function(standard);

    .home-program:hover & {
      color: color(slate);
    }

    @include breakpoint(phablet) {
      font-size: 3.6rem;
    }
  }

  .home-program__heading-container {
    padding-top: spacing(base-gamma);
    padding-bottom: spacing(base-delta);
    text-align: center;
  }

  .home-programs__about {
    @include column;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: spacing(base-gamma);

    @include breakpoint(tablet) {
      flex-direction: row;
      width: percentage(8 / 12);
      padding-top: spacing(base-epsilon);
      margin-right: auto;
      margin-left: auto;
    }
  }

  .home-programs__about-heading {
    font-weight: font-weight(bold);
    font-size: 1.8rem;
    color: color(red);
    text-transform: uppercase;

    @include breakpoint(phablet) {
      font-size: 3.3rem;
    }
  }

  .home-programs__about-body {
    margin-top: spacing(base-gamma);

    @include breakpoint(tablet) {
      margin-top: 0;
      margin-left: percentage(1/12);
    }
  }

  .home-programs__about-heading,
  .home-programs__about-copy {
    font-family: font-family(sans-serif);
  }

  .home-programs__about-copy {
    font-size: 1.5rem;
    line-height: 1.5;
    color: color(slate);

    @include breakpoint(phablet) {
      font-size: 2rem;
    }
  }

  .home-programs__about-link {
    display: inline-block;
    text-align: center;
    margin-top: spacing(base-delta);
    color: color(bronze);
  }

  .home-programs__about-link--wrapper {
    width: 100%;
    text-align: center;

    @include breakpoint(tablet) {
      text-align: left;
    }
  }

  .home-programs__background {
    position: absolute;
    top: -30px;
    left: 0;
    z-index: 0;
    height: 100%;
    stroke: color(lightest-grey);
  }
</style>
